<template>
  <div>
    <el-table
     v-loading='loading'
     :data="tableData"
     border 
     :cell-style="{padding:0,borderColor:'#000000'}"
     :header-cell-style="{borderColor:'#000000',color:'#0099ff'}"
     style="width: 100%;border: 1px solid #000000" 
     :row-style="{height:'100px'}"
     @cell-dblclick='DblclickCell'
    >

       <!-- 站点 -->
       <!-- <el-table-column prop="site" label="站点" width="110"> </el-table-column> -->

       <!-- 订单状态 -->
       <el-table-column prop="status" label="订单状态" width="90" align="center">
           <template slot-scope="scope">
                <el-tag
                :type="scope.row.status === '待付款' ? 'warning' : (scope.row.status === '正在处理' ? 'primary' : (scope.row.status === '已取消' ? 'info' : (scope.row.status === '已完成' ? 'success' : (scope.row.status === '失败订单' ? 'danger' : 'text'))))"
                disable-transitions>
                  {{scope.row.status}}
                </el-tag>
           </template>
       </el-table-column>

       <!-- 订单id -->
       <el-table-column prop="ID_" label="订单ID" width="60px" align="center"></el-table-column>

       <!-- 商品id -->
       <el-table-column prop="product_id" label="商品ID" width="140px" align="center"></el-table-column>

       <!-- 下单时间 -->
       <el-table-column prop="date_created_gmt" label="下单时间" width="95px" align="center"></el-table-column>

       <!-- 付款时间 -->
       <el-table-column prop="date_paid_gmt" label="付款时间" width="95px" align="center"></el-table-column>

       <!-- SKU -->
       <!-- <el-table-column prop="sku" label="SKU" width="100px"></el-table-column> -->

       <!-- 国际物流单号 -->
       <el-table-column prop="int_no" label="国际物流单号" width="140px" align="center"></el-table-column>

       <!-- 图片 -->
       <el-table-column label="图片" width="50px" align="center">
        <template slot-scope="scope">
          <el-popover placement="right" width="500" trigger="click">
            <img :src="scope.row.img" alt="暂无图片" width="500px" height="500px">
            <img :src="scope.row.img" alt="暂无图片" width="30px" height="30px" slot="reference">
          </el-popover>
        </template>
       </el-table-column>
       <!-- <el-table-column label="图片" width="120">
          <template slot-scope="scope">
              <img :src="scope.row.img" alt="暂无图片" width="100">
          </template>
       </el-table-column> -->

      <!-- 商品名称 -->
      <el-table-column prop="product_name" label="商品名称" width="150px" align="center"></el-table-column>

      <!-- 定制信息 -->
      <el-table-column label="定制信息" align="center">
        <template slot-scope="scope">
          <div><strong style="color:red">尺码:</strong> {{scope.row.size}}</div>
          <div><strong style="color:green">袖标:</strong> {{typeof(scope.row.armband) == 'object' ? '按图' : scope.row.armband}}</div>
          <div><strong style="color:blue">配件:</strong> {{typeof(scope.row.accessories) == 'object' ? '按图' : scope.row.accessories}}</div>
          <div><strong style="color:cyan">字号:</strong> {{scope.row.word_no}}</div>
        </template>
      </el-table-column>

      <!-- 袖标 -->
      <el-table-column label="袖标" width="125" align="center">
        <template slot-scope="scope" v-if="typeof(scope.row.armband) == 'object' ? true : false">
          <span v-for="(item,index) in scope.row.armband" :key="index">
              <el-popover placement="left" trigger="click" width="300">
                <img :src="item" width="100%" style="background:gray" />
                <img
                  slot="reference"
                  :src="item"
                  :alt="123"
                  width="48px" height="48px"
                  style="margin:1px;background:gray"
                />
              </el-popover>
            </span>
        </template>
      </el-table-column>

      <!-- 配件 -->
      <el-table-column label="配件" width="125" align="center">
        <template slot-scope="scope" v-if="typeof(scope.row.accessories) == 'object' ? true : false">
          <span v-for="(item,index) in scope.row.accessories" :key="index">
              <el-popover placement="left" trigger="click" width="300">
                <img :src="item" width="100%" />
                <img
                  slot="reference"
                  :src="item"
                  :alt="123"
                  width="50px" height="50px"
                />
              </el-popover>
            </span>
        </template>
      </el-table-column>
      
      <!-- 数量 -->
      <el-table-column prop="quantity" label="数量" width="40px" align="center"></el-table-column>

      <!-- 采购价 -->
      <el-table-column label="采购价" width="70px" align="center">
        <template slot-scope="scope">
          <span v-if='!scope.row.edit'>{{scope.row.cgj}}</span>
          <el-input size='mini' type='number' ref="CGJ" v-else v-model="scope.row.cgj" @blur='HandleBlur(scope.row)'>{{scope.row.cgj}}</el-input>
        </template>
      </el-table-column>

      <!-- 客户备注 -->
      <el-table-column prop="customer_note" label="客户备注" width="100px" align="center"></el-table-column>

      <!-- 商品备注 -->
      <el-table-column label="商品备注" width="100px" align="center">
          <template slot-scope="scope">
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.product_note placement="top">
                  <el-button type="primary" size="mini" v-show="scope.row.product_note">客服备注</el-button>
                </el-tooltip>
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.warehouse_note placement="left">
                  <el-button style="margin-left: 0;margin-top: 10px;" type="success" size="mini" v-show="scope.row.warehouse_note">仓库备注</el-button>
                </el-tooltip>
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.logistics_note placement="bottom">
                  <el-button style="margin-left: 0;margin-top: 10px;" type="warning" size="mini" v-show="scope.row.logistics_note">物流备注</el-button>
                </el-tooltip>
              </template>
      </el-table-column>

      <!-- 商品状态 -->
      <el-table-column align="center" prop="product_status" label="商品状态" width="130px"  :filter-method = "filterproduct" :filters="[{text:'待审核', value:'待审核'},{text:'待发货', value:'待发货'},{text:'待发货-制作中', value:'待发货-制作中'},{text:'待处理', value:'待处理'},{text:'仓库已发货', value:'仓库已发货'},{text:'已到货代', value:'已到货代'},{text:'物流已发货', value:'物流已发货'},{text:'异常', value:'异常'},{text:'暂停', value:'暂停'},{text:'已取消', value:'已取消'},{text:'已退款', value:'已退款'},{text:'缺货', value:'缺货'}]">
          <template slot-scope="scope">
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.inland_number placement="top">
                  <el-button
                   :type="scope.row.product_status === '待审核' ? 'danger' : (scope.row.product_status === '待发货' ? 'warning' : (scope.row.product_status === '待发货-制作中' ? 'info' : (scope.row.product_status === '仓库已发货' ? 'success' : (scope.row.product_status === '已到货代' ? 'primary' : (scope.row.product_status === '物流已发货' ? 'success' : (scope.row.product_status === '异常' ? 'danger' : (scope.row.product_status === '暂停' ? 'danger' : (scope.row.product_status === '已取消' ? '' : (scope.row.product_status === '已退款' ? 'warning' : (scope.row.product_status === '缺货' ? 'info' : (scope.row.product_status === '待处理' ? 'info' : '')))))))))))" 
                   size="mini">
                      {{scope.row.product_status}}
                  </el-button>
                </el-tooltip>
          </template>
      </el-table-column>

      <!-- 价格 -->
      <!-- <el-table-column prop="price" label="价格" width="70px"></el-table-column> -->

      <!-- 物流方式 -->
      <el-table-column prop="shiptype" label="物流方式" width="60px" align="center"></el-table-column>

      <!-- 物流商 -->
      <el-table-column prop="wls" label="物流商" width="50px" align="center"></el-table-column>

      <!-- 是否加急 -->
      <el-table-column align="center" :filters="[{text:'是',value:'是'},{text:'否',value:'否'}]" :filter-method="filterHandler" prop='isurgent' label="是否加急" width="55">
        <template slot-scope="scope">
          <span >{{scope.row.isurgent}}</span>
        </template>
      </el-table-column>

      <!-- 操作 -->
      <el-table-column label="操作" width="50px">
            <template slot-scope="scope">
                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="edit(scope.$index, scope.row)"
                    circle
                >
                </el-button>
                <!-- <el-button
                    style="margin-left: 0;margin-top: 10px;"
                    type="primary"
                    size="mini"
                    icon="el-icon-view"
                    @click="look(scope.$index, scope.row)"
                    circle
                >
                </el-button> -->
            </template>
       </el-table-column>
    </el-table>

    <el-dialog title="商品信息" :visible.sync="dialogFormVisible">
        <el-form :model="form">
            <el-form-item label="商品ID" :label-width="formLabelWidth">
            <el-input v-model="form.product_id" autocomplete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="商品名称" :label-width="formLabelWidth">
            <el-input v-model="form.product_name" autocomplete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="客服备注" :label-width="formLabelWidth">
            <el-input v-model="form.product_note" autocomplete="off" placeholder="请输入客服备注" disabled></el-input>
            </el-form-item>
            <el-form-item label="仓库备注" :label-width="formLabelWidth">
            <el-input v-model="form.warehouse_note" autocomplete="off" placeholder="请输入仓库备注"></el-input>
            </el-form-item>
            <el-form-item label="物流备注" :label-width="formLabelWidth">
            <el-input v-model="form.logistics_note" autocomplete="off" placeholder="请输入物流备注" disabled></el-input>
            </el-form-item>
            <el-form-item label="国内快递单号" :label-width="formLabelWidth">
            <el-input :disabled="form.product_status == '仓库已发货' ? false : true" v-model="form.inland_number" autocomplete="off" placeholder="请输入国内快递单号"></el-input>
            </el-form-item>
            <el-form-item label="商品状态" :label-width="formLabelWidth">
                <el-select v-model="form.product_status" placeholder="请选择商品状态">
                    <el-option label="待审核" value="待审核" disabled></el-option>
                    <el-option label="待发货" value="待发货" disabled></el-option>
                    <el-option label="待发货-制作中" value="待发货-制作中" disabled></el-option>
                    <el-option label="待处理" value="待处理"></el-option>
                    <el-option label="仓库已发货" value="仓库已发货"></el-option>
                    <el-option label="已到货代" value="已到货代" disabled></el-option>
                    <el-option label="物流已发货" value="物流已发货" disabled></el-option>
                    <el-option label="异常" value="异常"></el-option>
                    <el-option label="暂停" value="暂停"></el-option>
                    <el-option label="已取消" value="已取消" disabled></el-option>
                    <el-option label="已退款" value="已退款" disabled></el-option>
                    <el-option label="缺货" value="缺货"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
        </div>
    </el-dialog>

  </div>
</template>

<script>
import { getProduct,Edit,pilss,ckpllrspcgj } from "../../api/api";
export default {
  data() {
    return {
      tableData: [], //订单列表
      loading: true,
      dialogFormVisible: false,
      form: {
        product_id: '',
        product_name: '',
        product_note: '',
        warehouse_note: '',
        logistics_note: '',
        inland_number: '',
        product_status: ''
      },
      formLabelWidth: '120px',
    };
  },
  created() {
    var id_ = this.$route.query.id;
    var pd = this.$route.query.product_id;

    if(id_ != '' && id_ != null && id_ != undefined){
      getProduct(id_).then((res) => {

        for (const i of res) {
          if(i.armband == null || i.armband == undefined || i.armband == ''){
            i.armband = '无';
          }
          else if(i.armband.charAt(0) == "h"){
            i.armband = i.armband.split(",");
          }

          if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
            i.accessories = '无';
          }
          else if(i.accessories.charAt(0) == "h"){
            i.accessories = i.accessories.split(",");
          }

          if(i.edit == undefined){
            i.edit = false;
          }
        }
        this.tableData = res;
        this.loading = false;
      });
    }else if(pd != '' && pd != null && pd != undefined){
      var a = pd;
      var b = a.split(',');
      pilss(b).then((res) => {

        for (const i of res) {
          if(i.armband == null || i.armband == undefined || i.armband == ''){
            i.armband = '无';
          }
          else if(i.armband.charAt(0) == "h"){
            i.armband = i.armband.split(",");
          }

          if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
            i.accessories = '无';
          }
          else if(i.accessories.charAt(0) == "h"){
            i.accessories = i.accessories.split(",");
          }

          if(i.edit == undefined){
            i.edit = false;
          }
        }

        // console.log(res);
        // for (var i of res) {
          // if(i.armband == null || i.armband == ""){
          //   i.armband = "无";
          // }
          // if(i.accessories == null || i.accessories == ""){
          //   i.accessories = "无";
          // }
          // if(i.word_no == null || i.word_no == "" || i.word_no == "null"){
          //   i.word_no = "无";
          // }
        //   i.pro_det = `<br/>配件:${i.accessories}<br/>字号:${i.word_no}<br/>尺码:${i.size}<br/>袖标:${i.armband}`;
        // }
        this.tableData = res;
        this.loading = false;
      })
    }
  },
  methods: {

    // 筛选是否加急
    filterHandler(value, row) {
      if(value === '否'){
        return row.isurgent === '';
      }else{
        return row.isurgent === value;
      }
    },

    // 双击单元格显示input输入框
    // DblclickCell(row, column, cell, event){
    DblclickCell(row){
      this.$set(row,'edit',true);
      // input输入框自动获取焦点
      this.$nextTick(() => {
        this.$refs.CGJ.focus();
      })
    },

    // input输入框失去焦点
    HandleBlur(row){
      this.$set(row,'edit',false);
      this.upCgj = {
        cgj:row.cgj,
        product_id:row.product_id
      }
      if(row.cgj == ''){
        this.$message({
          message:'采购价为空,请先输入采购价',
          type:'warning'
        })
        return false
      }
      ckpllrspcgj(this.upCgj).then(res => {
        if(res.code == 200){
          this.$message({
            message:res.msg,
            type:'success'
          })
        }else if(res.code == 404){
          this.$message({
            message:res.msg,
            type:'warning'
          })
        }
      })
    },

    //编辑
    edit(index,row){
      this.dialogFormVisible = true;
      this.form = {
          product_id: row.product_id,
          product_name: row.product_name,
          product_note: row.product_note,
          warehouse_note: row.warehouse_note,
          logistics_note: row.logistics_note,
          inland_number: row.inland_number,
          product_status: row.product_status
      }
    },

    //取消编辑
    cancel(){
        this.dialogFormVisible = false;
        this.$message('取消编辑成功！！！');
    },

    //确定编辑
    confirm(){
      // console.log(this.form.inland_number);
      if((this.form.inland_number == '' || this.form.inland_number == undefined) && this.form.product_status == "仓库已发货"){
          this.$message({
              message:'仓库已发货时，国内快递单号不能为空！！！',
              type:'error'
          })
          return false;
      }else{
        var timee = new Date();
        var timeee = this.$moment(timee.getTime()).format("YYYY-MM-DD HH:mm:ss");
        var params = {
          product_id: this.form.product_id,
          product_name: this.form.product_name,
          product_note:this.form.product_note,
          warehouse_note:this.form.warehouse_note,
          logistics_note:this.form.logistics_note,
          inland_number:this.form.inland_number,
          product_status:this.form.product_status,
          person:'ck',
          time:timeee
        };
        Edit(params).then(res => {
          if(res.code === 200){
            this.loading = true;
            for(var i of this.tableData){
              if(i.product_id == this.form.product_id){
                i.product_name = this.form.product_name;
                i.product_note = this.form.product_note;
                i.warehouse_note = this.form.warehouse_note;
                i.logistics_note = this.form.logistics_note;
                i.inland_number = this.form.inland_number;
                i.product_status = this.form.product_status;
              }
            }
            this.loading = false;
            this.$message({
              message: '编辑成功！！！',
              type: 'success'
            });
          }else{
            this.$message({
              message: '编辑失败！！！',
              type: 'error'
            });
          }
        }).catch((error) => {
          console.log(error);
        });
        this.dialogFormVisible = false;
      }
      // // this.reload();
    },

    //查看详情
    look(index, row){
        const routeData = this.$router.resolve({ path: "/home/Orderdetail_", query: { site: row.site, ID_: row.ID_ } });
        window.open(routeData.href, '_blank');
    },

    // 商品状态筛选
    filterproduct(value, row){
      return row.product_status === value;
    },
  },
};
</script>

<style lang="scss" scoped>
  // 隐藏数字输入框后面的上下调节按钮
  /deep/ input::-webkit-outer-spin-button,
  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    appearance: none !important;
  }
  /deep/ input[type="number"] {
    -moz-appearance: textfield !important;
    appearance: textfield !important;
  }
</style>
